(function () {
    'use strict';

    angular.module("imApp").factory("stockCorrCodeLangsService", ['$ihttp', function ($ihttp) {
        let service = {
            listStockCorrectionCodeLanguages: function (parms) {
                return $ihttp.post({
                    method: 2486,
                    parameters: parms || {}
                });
            },
            saveObj: function (list) {
                return $ihttp.post({
                    method: 2487,
                    parameters: list
                });
            }
        };

        return service;
    }]);
})();
